export const initialState = {
  changeVar: 0,
  items: {
    AlienNot: require("../assets/AlienNot.png"),
    CoyPaste: require("../assets/CoyPaste.png"),
    Dismond: require("../assets/Dismond.png"),
    bountyPlayBtn: require("../assets/Whiteplay.png"),
    Bar: require("../assets/Bar.png"),
    Circle: require("../assets/Circle.png"),
    Bag: require("../assets/Bag.png"),
    Porfile: require("../assets/profile.png"),
    play_circle_filled: require("../assets/img/play_circle_filled.png"),
    circle: require("../assets/img/x-circle.png"),
    share: require("../assets/img/share.png"),
  },
};
const reducer = (state, action) => {
  // Error Message
  if (action.type === "change") {
    // let va;
    // let item;
    // if (state.changeVar === 0) {
    //   va = 1;
    // } else {
    //   va = 0;
    // }
    // if (state.changeVar === 0) {
    //   document.documentElement.style.setProperty("--clr-Blue5", "#F6F8FF");
    //   document.documentElement.style.setProperty("--clr-grey5", "#FFF");
    //   document.documentElement.style.setProperty("--clr-white", "#000");
    //   document.documentElement.style.setProperty("--clr-white1", "#000");
    //   document.documentElement.style.setProperty("--clr-gray8", "#000");
    //   document.documentElement.style.setProperty("--clr-black7", "#F9FAFB");
    //   document.documentElement.style.setProperty("--clr-grey4", "#000");
    //   document.documentElement.style.setProperty("--clr-black", "#FFF");
    //   document.documentElement.style.setProperty("--clr-Blue10", "#FFF");
    //   // sidebar
    //   document.documentElement.style.setProperty("--clr-black9", "#FFF");
    //   // Table search bar
    //   document.documentElement.style.setProperty("--clr-grey12", "#E6E6E6");
    //   // Button color
    //   document.documentElement.style.setProperty("--clr-red", "#24fe41");
    //   document.documentElement.style.setProperty("--clr-yellow1", "#5433ff");
    //   document.documentElement.style.setProperty("--clr-yellow2", "#20bdff");
    //   item = {
    //     AlienNot: require("../assets/Alien-black.png"),
    //     CoyPaste: require("../assets/Copy-paste-black.png"),
    //     Dismond: require("../assets/dimond-black.png"),
    //     bountyPlayBtn: require("../assets/BlackPLaybtn.png"),
    //     Bar: require("../assets/BarBlack.png"),
    //     Circle: require("../assets/CircleBlack.png"),
    //     Bag: require("../assets/BagBlack.png"),
    //     Porfile: require("../assets/profileBlack.png"),
    //     play_circle_filled: require("../assets/LargerBlackPlayBtn.png"),
    //     circle: require("../assets/x-circleBlack.png"),
    //     share: require("../assets/ShareBlackImg.png"),
    //   };
    // } else {
    //   document.documentElement.style.setProperty("--clr-Blue5", "#252c48");
    //   document.documentElement.style.setProperty("--clr-grey5", "#505971");
    //   document.documentElement.style.setProperty("--clr-white", "#fff");
    //   document.documentElement.style.setProperty("--clr-white1", "#e4e7ec");
    //   document.documentElement.style.setProperty("--clr-gray8", "#d7d7d7");
    //   document.documentElement.style.setProperty("--clr-black7", "#1f2036");
    //   document.documentElement.style.setProperty("--clr-grey4", "#b8b8b8");
    //   document.documentElement.style.setProperty("--clr-black", "#000");
    //   document.documentElement.style.setProperty("--clr-Blue10", "#40496f");
    //   // sidebar
    //   document.documentElement.style.setProperty("--clr-black9", "#1c2039");
    //   // Table search bar
    //   document.documentElement.style.setProperty("--clr-grey12", "#b8b8b8");
    //   // Button color
    //   document.documentElement.style.setProperty("--clr-red", "#c02425");
    //   document.documentElement.style.setProperty("--clr-yellow1", "#fdfc47");
    //   document.documentElement.style.setProperty("--clr-yellow2", "#24fe41");
    //   item = {
    //     AlienNot: require("../assets/AlienNot.png"),
    //     CoyPaste: require("../assets/CoyPaste.png"),
    //     Dismond: require("../assets/Dismond.png"),
    //     bountyPlayBtn: require("../assets/Whiteplay.png"),
    //     Bar: require("../assets/Bar.png"),
    //     Circle: require("../assets/Circle.png"),
    //     Bag: require("../assets/Bag.png"),
    //     Porfile: require("../assets/profile.png"),
    //     play_circle_filled: require("../assets/img/play_circle_filled.png"),
    //     circle: require("../assets/img/x-circle.png"),
    //     share: require("../assets/img/share.png"),
    //   };
    // }
    // return {
    //   changeVar: va,
    //   items: { ...item },
    // };
    return state;
  }
  return state;
};

export default reducer;
